import { Navigate, useRoutes } from 'react-router-dom';
// layouts
import DashboardLayout from './layouts/dashboard';
import SimpleLayout from './layouts/simple';
//
import Community from './pages/Community';

import SignupPage from './pages/SignupPage/SignupPage';
import FindPasswordPage from './pages/FindPasswordPage/FindPasswordPage';
import Page404 from './pages/Page404';
import Notice from './pages/Notice';
import DashboardAppPage from './pages/MainPage/DashboardAppPage';

import MyPage from './pages/MyPage';
import IntroductionPage from './pages/IntroductionPage';
import LicensePage from './sections/@dashboard/introduction/License';
import LicenseRegist from './sections/@dashboard/introduction/LicenseRegist';
import UseGuide from './pages/GuidePage/UseGuide';
import channel from './layouts/dashboard/header/channel';
import Dashboard from './pages/DashBoard';
import Failed from './pages/Failed';
import Success from './pages/Success';
import LicenseUpgrade from './pages/LicenseUpgrade';
import UpdateSuccess from './pages/UpdateSuccess';
import LoginPage from './pages/LoginPage/LoginPage';
import DownloadPage from './pages/DownloadPage/DownloadPage';
// ----------------------------------------------------------------------

export default function Router() {
  const routes = useRoutes([
    {
      path: '/',
      element: <DashboardLayout />,
      children: [
        { element: <Navigate to="/app" />, index: true },
        { path: 'intro', element: <IntroductionPage /> },
        { path: 'license', element: <LicensePage /> },
        { path: 'app', element: <DashboardAppPage /> },
        { path: 'guide', element: <UseGuide /> },
        { path: 'notice', element: <Notice /> },
        { path: 'community', element: <Community /> },
        { path: 'mypage', element: <MyPage /> },
        { path: 'license_regist', element: <LicenseRegist /> },
        { path: 'license_upgrade', element: <LicenseUpgrade /> },
        { path: 'download', element: <DownloadPage /> },
        { path: 'dashboard', element: <Dashboard /> },
        // { path: 'diorco', element: <DashboardAppPage /> },
      ],
    },
    { path: 'update_success', element: <UpdateSuccess /> },
    { path: 'success', element: <Success /> },
    { path: 'failed', element: <Failed /> },
    {
      path: '/login',
      element: <LoginPage />,
    },
    {
      path: '/signup',
      element: <SignupPage />,
    },
    {
      path: '/find',
      element: <FindPasswordPage />,
    },
    {
      element: <SimpleLayout />,
      children: [
        { element: <Navigate to="/app" />, index: true },
        { path: '404', element: <Page404 /> },
        { path: '*', element: <Navigate to="/404" /> },
      ],
    },
    {
      path: '*',
      element: <Navigate to="/404" replace />,
    },
  ]);
  channel.boot({
    pluginKey: `${process.env.REACT_APP_CHANNEL_BOT_API_KEY}`, // please fill with your plugin key
    memberId: '유저ID',
    profile: {
      name: '방문 손님',
      email: '유저Email',
      id: '유저ID',
    },
  });
  return routes;
}
